import request from "@utils/request";
import axios from "axios";

/**
 * 初始化
 * @param {*} data
 */
export function initData(data) {
  return request.post("/Index/init", data);
}

/**
 * 首页
 * @param {*} data
 */
export function index(data) {
  return request.post("/Index/index", data);
}

/**
 * 雷霆下载
 * @param {*} parms
 */
export function leitingDownload(parms) {
  let mid = "";
  var reg = new RegExp("(^|&)" + parms + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    var bodyFormData = new FormData();
    mid = encodeURIComponent(r[2]);
    bodyFormData.append("id", mid);
    window.mid = mid;
  }
  return axios({
    headers: {
      "Content-Type": "application/json"
    },
    method: "post",
    // https://leiting.feishu.cn/sheets/shtcnalEVlP3YSVaW2DrIGDE47d
    url: "//game.leiting.com/client/api/getDownloadUrl/43",
    data: bodyFormData
  })
    .then(res => {
      console.log(res);
      if (res.data.status !== "success")
        return Promise.reject({ msg: "请求失败" });
      console.log("download", res.data);
      window.android_url = res.data.download_arr.android_url;
      window.ios_url = res.data.download_arr.ios_url;
      return Promise.resolve(res.data);
    })
    .catch(err => {
      return Promise.reject({ msg: err.msg || "系统繁忙" });
    });
}

/**
 * 详情
 * @param {*} data
 */
export function articleDetail(data) {
  return request.post("/Article/detail.html", data);
}

/**
 * 详情
 * @param {*} data
 */
export function articlenNews(data) {
  return request.post("/Article/news.html", data);
}
